import React from 'react';
import ListTemplates from '../components/TemplateBots/ListTemplates';
import AuthenticatedLayout from '../components/AuthenticatedLayout';

export default function ListBotTemplates() {
    return (
        <AuthenticatedLayout title="Templates Lifty">
            <ListTemplates />
        </AuthenticatedLayout>
    );
}
